// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-card {
  transition: transform 0.2s;
  border: 1px solid #dee2e6;
}

.image-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.image-preview {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.image-preview img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.image-card .card-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

.btn-group {
  white-space: nowrap;
}

/* Custom scrollbar for URL input */
.image-card .form-control {
  font-size: 12px;
  font-family: monospace;
}

/* Add spacing between buttons in the toolbar */
.btn-group .btn {
  margin-right: 2px;
}

/* Make the input button group look better */
.input-group .btn {
  z-index: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .d-flex.justify-content-between {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .d-flex.justify-content-between > div {
    margin-top: 10px;
  }
  
  .btn-group {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  
  .btn-group .btn {
    margin-bottom: 5px;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/EbayImageExtractor.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".image-card {\n  transition: transform 0.2s;\n  border: 1px solid #dee2e6;\n}\n\n.image-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.image-preview {\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.image-preview img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.image-card .card-footer {\n  background-color: #f8f9fa;\n  border-top: 1px solid #dee2e6;\n}\n\n.btn-group {\n  white-space: nowrap;\n}\n\n/* Custom scrollbar for URL input */\n.image-card .form-control {\n  font-size: 12px;\n  font-family: monospace;\n}\n\n/* Add spacing between buttons in the toolbar */\n.btn-group .btn {\n  margin-right: 2px;\n}\n\n/* Make the input button group look better */\n.input-group .btn {\n  z-index: 0;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .d-flex.justify-content-between {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n  \n  .d-flex.justify-content-between > div {\n    margin-top: 10px;\n  }\n  \n  .btn-group {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n  }\n  \n  .btn-group .btn {\n    margin-bottom: 5px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
